module.exports = __webpack_public_path__ + "img/XCircle.61a87cba.svg";